import { render, staticRenderFns } from "./RefsReport.vue?vue&type=template&id=6b89263c"
import script from "./RefsReport.vue?vue&type=script&lang=ts"
export * from "./RefsReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports